"use strict";
const PusherFactory = function() {
  this.createInstance = function() {
    return new Pusher(PusherConfig.apiKey);
  };
};
const pusherFactory = new PusherFactory();
export default pusherFactory;
